import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { DealFolderForm } from "store/types";

export type IHandleCreateSurvey = (data: DealFolderForm) => void;

export function useCreateSurveyHook(): IHandleCreateSurvey {
  const { push } = useHistory();

  return useCallback((data: DealFolderForm): void => {
    push({
      pathname: `/main/deal/${data.deal_id}/workspace/form/${data.id}`,
      search: window.location.search
    });
  }, []);
}
